import { render, staticRenderFns } from "./AppLangNav.vue?vue&type=template&id=725f6749&scoped=true"
import script from "./AppLangNav.vue?vue&type=script&lang=js"
export * from "./AppLangNav.vue?vue&type=script&lang=js"
import style0 from "./AppLangNav.vue?vue&type=style&index=0&id=725f6749&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725f6749",
  null
  
)

export default component.exports